/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.security.reports-permissions'},
});

const ReportsPermissionsItem = () => (
  <RouteLinkItem
    route="midas/settings/security/reports-permissions"
    title={messages.title}
  />
);

export default ReportsPermissionsItem;
